import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RiLockLine, RiMailLine, RiEyeLine, RiEyeOffLine, RiShieldLine } from 'react-icons/ri';
import { C } from '../../data/constants';
import { useAuth } from '../../context/AuthContext';
import KitsuMark from '../../components/brand/KitsuMark';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { adminLogin, authLoading, authError, setAuthError } = useAuth();

  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);

  const handleLogin = async (event) => {
    event?.preventDefault();
    setAuthError('');
    if (!email || !password) { setAuthError('Please fill in all fields.'); return; }
    const result = await adminLogin({ email, password });
    if (result.success) navigate('/admin/overview');
  };

  return (
    <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center', justifyContent:'center', padding:24, position:'relative', overflow:'hidden' }}>
      <div style={{ position:'absolute', inset:0, background:'radial-gradient(ellipse 60% 50% at 50% 50%, rgba(249,115,22,0.07), transparent 70%)', pointerEvents:'none' }} />

      <div className="ks-card anim-pop" style={{ padding:'44px 40px', width:'100%', maxWidth:420, position:'relative', zIndex:1 }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ marginBottom:10, display:'flex', justifyContent:'center' }}>
            <KitsuMark size={46} animation="pop" />
          </div>
          <div style={{ display:'inline-flex', alignItems:'center', gap:6, background:C.accentDim, border:`1px solid ${C.accentBorder}`, borderRadius:100, padding:'4px 12px', marginBottom:14, fontSize:11, color:C.accent, fontWeight:700 }}>
            <RiShieldLine size={11} /> ADMIN ACCESS ONLY
          </div>
          <h1 style={{ fontSize:22, fontWeight:900, letterSpacing:-0.7, marginBottom:5 }}>Admin Login</h1>
          <p style={{ color:C.muted, fontSize:13 }}>Sign in to the KitsuSpeak control panel</p>
        </div>

        <form onSubmit={handleLogin} style={{ display:'flex', flexDirection:'column', gap:12 }}>
          <div style={{ position:'relative' }}>
            <RiMailLine size={15} style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', color:C.muted }} />
            <input
              className="ks-input"
              style={{ paddingLeft:38 }}
              placeholder="Admin email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          <div style={{ position:'relative' }}>
            <RiLockLine size={15} style={{ position:'absolute', left:13, top:'50%', transform:'translateY(-50%)', color:C.muted }} />
            <input
              className="ks-input"
              style={{ paddingLeft:38, paddingRight:42 }}
              placeholder="Password"
              type={showPass ? 'text' : 'password'}
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <div onClick={() => setShowPass(s => !s)} style={{ position:'absolute', right:13, top:'50%', transform:'translateY(-50%)', color:C.muted, cursor:'pointer' }}>
              {showPass ? <RiEyeOffLine size={15} /> : <RiEyeLine size={15} />}
            </div>
          </div>

          {authError && (
            <div style={{ background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.28)', borderRadius:9, padding:'10px 14px', fontSize:13, color:C.red, fontWeight:600 }}>
              {authError}
            </div>
          )}

          <button
            type="submit"
            className="btn-primary"
            style={{ width:'100%', justifyContent:'center', padding:14, fontSize:15, marginTop:4 }}
            disabled={authLoading}
          >
            {authLoading ? <div className="spinner" /> : 'Sign In to Admin Panel'}
          </button>
        </form>

        <div style={{ textAlign:'center', marginTop:20, fontSize:12, color:C.faint }}>
          Use the credentials set in your backend <code>.env</code> file
        </div>
        <div style={{ textAlign:'center', marginTop:10 }}>
          <span style={{ color:C.faint, fontSize:12, cursor:'pointer' }} onClick={() => navigate('/')}>
            ← Back to home
          </span>
        </div>
      </div>
    </div>
  );
}
